import { useState } from "react";
import { Link, replace, useNavigate } from "react-router-dom";
import useAuth from "./hooks/useAuth.js";
import api from "./api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faKey,
  faSignOutAlt,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";

const Header = ({ setIsAuthenticated }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { user } = useAuth();
  // const navigate = useNavigate();

  const toggleDropdown = (e) => {
    e.preventDefault();
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleLogout = async () => {
    try {
      await api.post("/deconnexion", null, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      localStorage.removeItem("user");
      localStorage.removeItem("token");

      console.log("Contenu de set", setIsAuthenticated);
      // setIsAuthenticated(false);
      window.location.href = "/connexion";
      // navigate("/connexion");
    } catch (error) {
      alert("Erreur lors de la déconnexion");
      console.log("Erreur lors de la déconnexion");
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      // navigate("/");
      window.location.href = "/connexion";
    }
  };

  return (
    <>
      <nav
        className="navbar navbar-expand-lg shadow-sm"
        style={{ backgroundColor: "white" }}
      >
        <div className="container-fluid d-flex justify-content-between mx-md-5">
          {/* LOGO */}
          <Link to="/" className="navbar-brand">
            <img
              src="/images/COMMANDO.png"
              alt="Logo"
              width="80"
              height="80"
              className="d-inline-block align-text-top"
            />
          </Link>

          {/* TOGGLER MOBILE */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Menus  */}
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto align-items-center gap-4">
              <li className="nav-item">
                <Link to="/about" className="nav-link fw-semibold text-dark">
                  A propos
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/new_order"
                  className="nav-link fw-semibold text-dark"
                >
                  Menus
                </Link>
              </li>
            </ul>
          </div>

          {/* NAVIGATION CONTENT */}
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto align-items-center gap-4">
              {user ? (
                <>
                  <li className="nav-item">
                    <Link
                      to="/dashboard"
                      className="nav-link fw-semibold text-dark"
                    >
                      Tableau De Bord
                    </Link>
                  </li>
                  <li className="nav-item dropdown">
                    <button
                      className="btn d-flex align-items-center gap-2 border-0"
                      onClick={toggleDropdown}
                      style={{ background: "transparent" }}
                    >
                      <img
                        src="/images/profil.jpg"
                        alt="Profil"
                        className="rounded-circle border"
                        width="45"
                        height="45"
                        style={{ objectFit: "cover" }}
                      />
                      <FontAwesomeIcon
                        icon={faChevronDown}
                        size="xs"
                        className="text-muted"
                      />
                    </button>

                    <ul
                      className={`dropdown-menu dropdown-menu-end shadow border-0 ${isDropdownOpen ? "show" : ""}`}
                      style={{ position: "absolute", right: 0 }}
                    >
                      {/* <li>
                      <Link to="/profil" className="dropdown-item py-2">
                        <FontAwesomeIcon icon={faUser} className="me-2 text-primary" /> Mon profil
                      </Link>
                    </li>
                    <li>
                      <Link to="/reset_password" className="dropdown-item py-2">
                        <FontAwesomeIcon icon={faKey} className="me-2 text-warning" /> Mot de passe
                      </Link>
                    </li> */}
                      {/* <li><hr className="dropdown-divider" /></li> */}
                      <li>
                        <button
                          onClick={handleLogout}
                          className="dropdown-item py-2 text-danger fw-bold"
                        >
                          <FontAwesomeIcon
                            icon={faSignOutAlt}
                            className="me-2"
                          />{" "}
                          Se déconnecter
                        </button>
                      </li>
                    </ul>
                  </li>
                </>
              ) : (
                <li className="nav-item">
                  <Link
                    to="/connexion"
                    className="btn btn-outline-info rounded-pill px-4"
                  >
                    Connexion
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
